import {
  Box,
  Button,
  HStack,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import {
  createPersonalInterview,
  getPersonalInterviewData,
} from "API/personalInterviewApi";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useHistory } from "react-router-dom";

const EditAboutSelf = ({ tab, setTab, user: currUser }) => {
  const toast = useToast();
  const history = useHistory();
  const [aboutSelf, setAboutSelfLabels] = useState([
    { label: "Name", values: "", new: false },
    { label: "Father", values: "", new: false },
    { label: "Mother", values: "", new: false },
    { label: "Brother", values: "", new: false },
    { label: "Sister", values: "", new: false },
    { label: "Date Of Birth", values: "", new: false },
    { label: "Place Of Birth", values: "", new: false },
    { label: "School", values: "", new: false },
    { label: "School Name", values: "", new: false },
    { label: "Medium Of Instruction", values: "", new: false },
    { label: "Place", values: "", new: false },
    { label: "Till Class", values: "", new: false },
    { label: "Achievements Sports", values: "", new: false },
    { label: "Achievements Academics", values: "", new: false },
    { label: "Achievements Others", values: "", new: false },
    { label: "Jr. College", values: "", new: false },
  ]);

  const createPersonalInterviewMutation = useMutation(createPersonalInterview);

  // const { user } = useAppSelector((state) => state.auth);
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(currUser);
  }, [currUser]);

  const { data: personalInterviewData } = useQuery(
    ["personalInterview"],
    () => getPersonalInterviewData(user),
    {
      enabled: !!user,
    }
  );

  useEffect(() => {
    if (
      personalInterviewData?.data?.aboutSelf &&
      personalInterviewData?.data?.aboutSelf.length !== 0
    ) {
      const newFields = [];
      personalInterviewData?.data?.aboutSelf.map((field) =>
        newFields.push({
          label: field.label,
          values: field.values,
          new: false,
        })
      );
      setAboutSelfLabels(newFields);
    }
  }, [personalInterviewData]);

  const handleInputChange = (e, index) => {
    const newFields = [...aboutSelf];
    newFields[index].values = e.target.value;
    setAboutSelfLabels(newFields);
  };

  const handleNewInputLabelChange = (e, index) => {
    const newFields = [...aboutSelf];
    newFields[index].label = e.target.value;
    setAboutSelfLabels(newFields);
  };

  const handleInsertField = (index) => {
    const newFields = [...aboutSelf];
    newFields.splice(index + 1, 0, { label: "", values: "", new: true });
    setAboutSelfLabels(newFields);
  };

  const handleRemoveInputField = (index) => {
    const newFields = [...aboutSelf];
    newFields.splice(index, 1);
    setAboutSelfLabels(newFields);
  };

  const handleSaveClick = async ({ next }) => {
    const data = [];
    aboutSelf.map((field, index) => {
      if (field.label !== "") {
        data.push({
          label: field.label,
          values: field.values === "" ? "N / A" : field.values,
          order: index,
        });
      }
      return "";
    });
    let response = await createPersonalInterviewMutation.mutateAsync({
      data,
      type: "aboutSelf",
      user,
    });
    if (response.success) {
      toast({
        title: response.message,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      if (next) setTab(tab + 1);
    }
  };

  return (
    <>
      <VStack w={"100%"} px={4}>
        {aboutSelf.map((key, index) =>
          !key.new ? (
            <Box w={"100%"} key={index}>
              <Text>{key.label}</Text>
              <HStack>
                <Input
                  onChange={(e) => handleInputChange(e, index)}
                  value={key.values}
                ></Input>
                <Button
                  colorScheme="teal"
                  fontSize={"xl"}
                  onClick={() => handleInsertField(index)}
                >
                  +
                </Button>
              </HStack>
            </Box>
          ) : (
            <Box w={"100%"} key={index}>
              {/* <HStack my={"16px"}>
                <Input value={"Field Label"} readOnly></Input>
                <Input value="Field Value" readOnly></Input>
                <Button
                  colorScheme="red"
                  onClick={() => handleRemoveInputField(index)}
                >
                  -
                </Button>
              </HStack> */}
              <HStack>
                <Input
                  placeholder="Field Label"
                  value={key.label}
                  onChange={(e) => handleNewInputLabelChange(e, index)}
                ></Input>
                <Input
                  placeholder="Field Value"
                  onChange={(e) => handleInputChange(e, index)}
                  value={key.values}
                ></Input>
                <Button
                  colorScheme="red"
                  onClick={() => handleRemoveInputField(index)}
                >
                  -
                </Button>
              </HStack>
            </Box>
          )
        )}
      </VStack>
      <HStack w="100%" px={4} py={"30px"}>
        <Button
          colorScheme="teal"
          onClick={() => handleSaveClick({ next: false })}
        >
          Save
        </Button>
        <Button
          colorScheme="teal"
          onClick={() => handleSaveClick({ next: true })}
        >
          Save & Next
        </Button>
        <Button
          bg={"grey"}
          color={"White"}
          onClick={() =>
            history.push({
              pathname: "/interview",
              state: { item: user },
            })
          }
        >
          Cancel
        </Button>
      </HStack>
    </>
  );
};

export default EditAboutSelf;
